var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-box"},_vm._l((_vm.resources),function(item){return _c('a',{key:'res_' + item.id,staticClass:"link-small",attrs:{"href":(item.image || {}).path}},[_c('app-svg-icon',{attrs:{"name":"brand/NG_PDF"}}),_vm._v("\n        "+_vm._s(item.name)+"\n    ")],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b932fa62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/dashboard/components/dashboard-resources.vue
// module id = null
// module chunks = 